import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useContext, useState } from 'react';
import { LayoutContainer, AccordionGroup, AccordionItem, Anchor, CountryLinkDropdown } from '@zooplus/ui-components';
import styles from './InfoListAndCountrySelector.module.scss.js';
import PageWidthContext from '../../contexts/PageWidthContext.js';

const InfoListAndCountrySelector = ({ footerInfoLinks, }) => {
    const pageWidth = useContext(PageWidthContext);
    return (jsx("section", { className: styles.infoListAndCountrySelector, children: jsxs(LayoutContainer, { className: styles.infoListAndCountrySelectorWrapper, variant: pageWidth, children: [jsx(InfoList, { items: [
                        { headline: footerInfoLinks.headline1, link: footerInfoLinks.linkList1 },
                        { headline: footerInfoLinks.headline2, link: footerInfoLinks.linkList2 },
                        { headline: footerInfoLinks.headline3, link: footerInfoLinks.linkList3 },
                    ] }), jsx(CountrySelector, { headline: footerInfoLinks.countrySelectorHeadline, countries: footerInfoLinks.countries })] }) }));
};
const InfoList = ({ items }) => {
    return (jsx(Fragment, { children: jsx("div", { className: styles.infoList, children: jsx(AccordionGroup, { className: styles.myAccordion, disableMinWidth: 1024, children: items.map(({ headline, link }, i) => (jsx(AccordionItem, { size: "large", title: headline, children: link.map((item, index) => (jsx(Anchor, { variant: "grey", className: styles.linkInsideAccordion, href: item.targetLink, children: item.linkText }, index))) }, i))) }) }) }));
};
const CountrySelector = ({ headline, countries }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggleOpen = () => {
        setIsOpen(!isOpen);
    };
    return (jsxs("div", { className: styles.countrySelector, children: [jsx("span", { className: styles.headline, children: headline }), jsx(CountryLinkDropdown, { menuId: "footer-country-selection-menu", autoSort: true, breakpoint: "md", onOpen: handleToggleOpen, onClose: handleToggleOpen, zIndex: 10000, items: countries.map(({ countryName, isCurrentShop, targetLink, flag }) => ({
                    href: targetLink,
                    image: {
                        url: `${flag?.image}?fm=webp&w=48`,
                        alt: flag?.altText,
                        height: 24,
                        width: 24,
                    },
                    isSelected: isCurrentShop,
                    country: countryName || '',
                })), triggerLabel: "fallback country" })] }));
};

export { InfoListAndCountrySelector as default };
//# sourceMappingURL=InfoListAndCountrySelector.js.map
